import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

function BannerCarousel() {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    fetch("http://kolibusiness.com/backend/get-banners.php")
      .then((res) => res.json())
      .then((data) => setBanners(data))
      .catch((err) => console.error("Banner fetch failed:", err));
  }, []);

  return (
    <div className="banner-wrapper">
 <Swiper
  modules={[Autoplay, Pagination]}
  autoplay={{ delay: 3500, disableOnInteraction: false }}
  pagination={{ clickable: true }}
  loop={true}
  slidesPerView={1}
  speed={800} // 
>

        {banners.map((banner, index) => (
<SwiperSlide key={index}>
  <div style={{
    width: '100%',
    height: 'auto',
    maxHeight: '450px', // ✅ desktop limit
    overflow: 'hidden'
  }}>
    <img
      src={banner.image_url}
      alt={`Slide ${index}`}
      style={{
        width: '100%',
        height: '100%',
        maxHeight: '450px',
        objectFit: 'cover',
        display: 'block'
      }}
    />
  </div>
</SwiperSlide>



        ))}
      </Swiper>
    </div>
  );
}

export default BannerCarousel;
